import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText'; 

const styles = StyleSheet.create({
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
    verticalAlign: 'middle',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
  },
  // Column specific styles
  srNoCell: {
    width: '5%',
  },
  detailsCell: {
    width: '55%',
  },
  pageNoCell: {
    width: '40%',
  },
  combinedCell: {
    width: '95%',
  },
  // Nested table styles with complete borders
  nestedTable: {
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    marginTop: 5,
  },
  nestedRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #000', // Add bottom border to each row
  },
  nestedHeaderCell: {
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
    padding: 3,
    fontSize: 9,
    borderRight: '1px solid #000',
    // borderBottom: '1px solid #000', // Ensure header has bottom border
    textAlign: 'center',
  },
  nestedCell: {
    padding: 3,
    height: 20,
    fontSize: 9,
    borderRight: '1px solid #000',
    // borderBottom: '1px solid #000', // Ensure cells have bottom border
    textAlign: 'center',
  },
  // Column widths for nested table
  degreeCell: { width: '25%' },
  boardCell: { width: '25%' },
  classCell: { width: '20%' },
  yearCell: { width: '30%' },
  bulletRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 6,
  },
  bulletSymbol: {
    width: 10,
    fontSize: 10,
    marginRight: 5,
  },
  bulletText: {
    flex: 1,
    fontSize: 10,
    textAlign: 'justify',
    lineHeight: 1.5,
  },
});

const SrScalePage2 = ({ result }) => {
  const tableData = [
    ['१४', `एकाच वेतन स्तरांमध्ये १२ वर्षे सलग अहर्ताकारी सेवा झाल्यामुळे देय वरिष्ठ वेतन श्रेणी/ स्तर`, result.payBandPromotion],
    ['१५', `सेवांतर्गत प्रशिक्षण (दाखल्याची सत्यप्रत सोबत जोडावी .)`, ],
    ['१६', `वेतन निश्चितीचा दिनांक वेतन निश्चिती मनासे नियम १९८१ च्या ११(२) मधील तरतुदी प्रमाणे पात्र दिनांक/ विकल्प दिनांक
            अ. मूळ वेतन संरचनेतील वेतन स्तर व वेतन(वरिष्ठ श्रेणी/स्तर मिळण्यापूर्वीचे वेतन  )
            ब) वरिष्ठ श्रेणीचे अनुज्ञेय वेतन स्तर व वेतन 
            (सुधारित वेतन नियंम  २०१९,   नियम क्र १३  नुसार )`
            , `${result.dateOfOption}
            
            अ) ${result.payBandPrevious}
               ${result.basicPayPrevious}
               
            ब) ${result.payBandPromotion}
               dsadasdfghuighrhgruigreiugh`],
    ['१७', `पुढील वेतनवाढीचा दिनांक (सुधारित वेतन नियंम  २०१९,   नियम क्र १० नुसार )`, 'dsadasdfghuighrhgruigreiugh'],
    // ['१८', `वेतन वाढीचा तपशील `, result.designation],
    ['१९ ', `इतर अनुषंगिक माहिती :`, result.designation],
  ];

  // Sample data for nested table (qualifications)
  const qualificationData = [
    {
      degree: 'बी.ए.',
      board: 'मुंबई विद्यापीठ',
      class: 'प्रथम श्रेणी',
      year: '२००५'
    },
    {
      degree: 'बी.एड.',
      board: 'पुणे विद्यापीठ',
      class: 'द्वितीय श्रेणी',
      year: '२००७'
    }
  ];

  return (
    <View size="A4" style={style.page}> 

      {/* Main Table */}
      <View style={[styles.table, { marginTop: 2 }]}>
        {/* Rows 1-5 */}
        {tableData.slice(0, 2).map(([srNo, details, value], index) => (
          <View style={styles.row} key={`row-${index}`}>
            <AutoText style={[styles.cell, styles.srNoCell]}>{srNo}</AutoText>
            <AutoText style={[styles.cell, styles.detailsCell]}>{details}</AutoText>
            <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
          </View>
        ))}

        {/* Special Row 5 with nested table */}
        <View style={styles.row}>
        <AutoText style={[styles.cell, styles.srNoCell]}></AutoText>
          <View style={[styles.cell, styles.combinedCell, { borderRight: '1px solid #000' }]}>
                   
            {/* Nested Table with complete borders */}
            <View style={styles.nestedTable}>
              {/* Header Row */}
              <View style={styles.nestedRow}>
                <AutoText style={[styles.nestedHeaderCell, styles.degreeCell]}>अ.क्र.</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.boardCell]}>प्रशिक्षण स्थळ</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.classCell]}>प्रशिक्षण (महिने)</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.yearCell]}>दिवस</AutoText>
              </View>
              
              {/* Data Rows */}
              {qualificationData.map((qual, idx) => (
                <View style={styles.nestedRow} key={`qual-${idx}`}>
                  <AutoText style={[styles.nestedCell, styles.degreeCell]}>१</AutoText>
                  <AutoText style={[styles.nestedCell, styles.boardCell]}>{result.trainingLocation}</AutoText>
                  <AutoText style={[styles.nestedCell, styles.classCell]}>{result.trainingDuration}</AutoText>
                  <AutoText style={[styles.nestedCell, styles.yearCell]}></AutoText>
                </View>
              ))}
              

            </View>
          </View>
        </View>

        {/* Rows 6-15 */}
        {tableData.slice(2, 4).map(([srNo, details, value], index) => (
          <View style={styles.row} key={`row-${index + 15}`}>
            <AutoText style={[styles.cell, styles.srNoCell]}>{srNo}</AutoText>
            <AutoText style={[styles.cell, styles.detailsCell]}>{details}</AutoText>
            <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
          </View>       
        ))}
         {/* Special Row 18 with nested table */}
         <View style={styles.row}>
          <AutoText style={[styles.cell, styles.srNoCell]}>१८</AutoText>
          <View style={[styles.cell, styles.combinedCell, { borderRight: '1px solid #000' }]}>
            <AutoText>वेतन वाढीचा तपशील</AutoText>
            
            {/* Nested Table with complete borders */}
            <View style={styles.nestedTable}>
              {/* Header Row */}
              <View style={styles.nestedRow}>
                <AutoText style={[styles.nestedHeaderCell, styles.degreeCell]}>अ.क्र.</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.boardCell]}>दिनांक</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.classCell]}>वेतन स्तर</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.yearCell]}>वेतन स्तरामधील मूळ वेतन</AutoText>
              </View>
              
              {/* Data Rows */}
              {qualificationData.map((qual, idx) => (
                <View style={styles.nestedRow} key={`qual-${idx}`}>
                  <AutoText style={[styles.nestedCell, styles.degreeCell]}></AutoText>
                  <AutoText style={[styles.nestedCell, styles.boardCell]}></AutoText>
                  <AutoText style={[styles.nestedCell, styles.classCell]}></AutoText>
                  <AutoText style={[styles.nestedCell, styles.yearCell]}></AutoText>
                </View>
              ))}
              

            </View>
          </View>
        </View>

        {tableData.slice(4, 5).map(([srNo, details, value], index) => (
          <View style={styles.row} key={`row-${index + 15}`}>
            <AutoText style={[styles.cell, styles.srNoCell]}>{srNo}</AutoText>
            <AutoText style={[styles.cell, styles.detailsCell]}>{details}</AutoText>
            <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
          </View>       
        ))}

        <AutoText style={[style.signature, { marginTop: 70}]}>कार्यालयीन प्रमुख </AutoText>
      </View>
    </View>
  );
};

export default SrScalePage2;